export const environment = {
    apiUrl: "/api/",
    loginGwoUrl: "https://moje.gwotest.pl/uzytkownik/",
    cookieName: "X-Authorization",
    domainName: ".gwotest.pl",
};
